import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [activeMenu, setActiveMenu] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);

  // Detect scroll position to toggle background
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setActiveMenu("");
    
    // Optional: Close mobile navbar collapse automatically on link click if using Bootstrap JS
    const navbarCollapse = document.getElementById("navbarMenu");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  // Toggle dropdown on click for mobile or touch devices
  const handleDropdownClick = (menuName, e) => {
    e.preventDefault();
    setActiveMenu(activeMenu === menuName ? "" : menuName);
  };

  return (
    <nav className={`navbar navbar-expand-lg navbar-dark aff-navbar fixed-top ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">

        {/* Logo */}
        <Link className="navbar-brand" to="/" onClick={handleLinkClick}>
          <img
            src="/images/affsoft-logo.png"
            alt="Affsoft" width={200}
            className="logo"
          />
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMenu"
          aria-controls="navbarMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarMenu">

          <ul className="navbar-nav mx-auto">

            <li className="nav-item">
              <Link className="nav-link active" to="/" onClick={handleLinkClick}>Home</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about-us" onClick={handleLinkClick}>About Us</Link>
            </li>

            {/* Managed Services */}
            <li
              className="nav-item dropdown"
              onMouseEnter={() => window.innerWidth > 991 && setActiveMenu("managed")}
              onMouseLeave={() => window.innerWidth > 991 && setActiveMenu("")}
            >
              <Link
                to="#"
                className="nav-link dropdown-toggle"
                onClick={(e) => handleDropdownClick("managed", e)}
              >
                Managed Services
              </Link>

              <ul className={`dropdown-menu ${activeMenu === "managed" ? "show" : ""}`}>
                <li><Link className="dropdown-item" to="/web-design-and-development" onClick={handleLinkClick}>Web Design and Development</Link></li>
                <li><Link className="dropdown-item" to="/mobile-app-development" onClick={handleLinkClick}>Mobile App Development</Link></li>
                <li><Link className="dropdown-item" to="/digital-marketing" onClick={handleLinkClick}>Digital Marketing</Link></li>
                <li><Link className="dropdown-item" to="/power-bi-services" onClick={handleLinkClick}>Power BI Services</Link></li>
                <li><Link className="dropdown-item" to="/servicenow-development" onClick={handleLinkClick}>ServiceNow Development</Link></li>
                <li><Link className="dropdown-item" to="/infrastructure-development" onClick={handleLinkClick}>Infrastructure Development</Link></li>
                <li><Link className="dropdown-item" to="/application-development" onClick={handleLinkClick}>Application Development</Link></li>
                <li><Link className="dropdown-item" to="/process-outsourcing" onClick={handleLinkClick}>Process Outsourcing</Link></li>
                <li><Link className="dropdown-item" to="/cloud-migration" onClick={handleLinkClick}>Cloud Migration</Link></li>
                <li><Link className="dropdown-item" to="/data-integration" onClick={handleLinkClick}>Data Integration</Link></li>
                <li><Link className="dropdown-item" to="/mainframes-computing" onClick={handleLinkClick}>Mainframe Computing</Link></li>
                <li><Link className="dropdown-item" to="/product-engineering" onClick={handleLinkClick}>Product Engineering</Link></li>
              </ul>
            </li>

            {/* Digital Transformation */}
            <li
              className="nav-item dropdown"
              onMouseEnter={() => window.innerWidth > 991 && setActiveMenu("digital")}
              onMouseLeave={() => window.innerWidth > 991 && setActiveMenu("")}
            >
              <Link
                to="#"
                className="nav-link dropdown-toggle"
                onClick={(e) => handleDropdownClick("digital", e)}
              >
                Digital Transformation
              </Link>

              <ul className={`dropdown-menu ${activeMenu === "digital" ? "show" : ""}`}>
                <li><Link className="dropdown-item" to="/customer-experience-and-cpq" onClick={handleLinkClick}>Customer Experience and CPQ</Link></li>
                <li><Link className="dropdown-item" to="/supply-chain-optimization" onClick={handleLinkClick}>Supply Chain Optimization</Link></li>
                <li><Link className="dropdown-item" to="/big-data-and-analytics" onClick={handleLinkClick}>Big Data and Analytics</Link></li>
                <li><Link className="dropdown-item" to="/mobility-and-ux" onClick={handleLinkClick}>Mobility and UX</Link></li>
                <li><Link className="dropdown-item" to="/ai-and-ml" onClick={handleLinkClick}>AI and ML</Link></li>
                <li><Link className="dropdown-item" to="/robotic-process-automation" onClick={handleLinkClick}>Robotic Process Automation</Link></li>
                <li><Link className="dropdown-item" to="/internet-of-things" onClick={handleLinkClick}>Internet of Things</Link></li>
                <li><Link className="dropdown-item" to="/human-capital-management" onClick={handleLinkClick}>Human Capital Management</Link></li>
              </ul>
            </li>

            {/* Technology */}
            <li
              className="nav-item dropdown"
              onMouseEnter={() => window.innerWidth > 991 && setActiveMenu("technology")}
              onMouseLeave={() => window.innerWidth > 991 && setActiveMenu("")}
            >
              <Link
                to="#"
                className="nav-link dropdown-toggle"
                onClick={(e) => handleDropdownClick("technology", e)}
              >
                Technology
              </Link>

              <ul className={`dropdown-menu ${activeMenu === "technology" ? "show" : ""}`}>
                <li><Link className="dropdown-item" to="/sap-enterprise-systems" onClick={handleLinkClick}>SAP Enterprise Systems</Link></li>
                <li><Link className="dropdown-item" to="/salesforce-platforms" onClick={handleLinkClick}>Salesforce Platforms</Link></li>
                <li><Link className="dropdown-item" to="/oracle-cloud-and-database-solutions" onClick={handleLinkClick}>Oracle Cloud and Database Solutions</Link></li>
                <li><Link className="dropdown-item" to="/microsoft-cloud-solutions" onClick={handleLinkClick}>Microsoft Cloud Solutions</Link></li>
                <li><Link className="dropdown-item" to="/aws-cloud-solutions" onClick={handleLinkClick}>AWS Cloud Solutions</Link></li>
                <li><Link className="dropdown-item" to="/netsuite-enterprise-solutions" onClick={handleLinkClick}>NetSuite Enterprise Solutions</Link></li>
              </ul>
            </li>

            {/* Industries */}
            <li
              className="nav-item dropdown"
              onMouseEnter={() => window.innerWidth > 991 && setActiveMenu("industries")}
              onMouseLeave={() => window.innerWidth > 991 && setActiveMenu("")}
            >
              <Link
                to="#"
                className="nav-link dropdown-toggle"
                onClick={(e) => handleDropdownClick("industries", e)}
              >
                Industries
              </Link>

              <ul className={`dropdown-menu ${activeMenu === "industries" ? "show" : ""}`}>
                <li><Link className="dropdown-item" to="/manufacturing-solutions" onClick={handleLinkClick}>Manufacturing Solutions</Link></li>
                <li><Link className="dropdown-item" to="/healthcare-and-biotech-solutions" onClick={handleLinkClick}>Healthcare and Biotech Solutions</Link></li>
                <li><Link className="dropdown-item" to="/automotive-solutions" onClick={handleLinkClick}>Automotive Solutions</Link></li>
                <li><Link className="dropdown-item" to="/high-tech-solutions" onClick={handleLinkClick}>High Tech Solutions</Link></li>
                <li><Link className="dropdown-item" to="/aerospace" onClick={handleLinkClick}>Aerospace</Link></li>
                <li><Link className="dropdown-item" to="/retail-and-distribution" onClick={handleLinkClick}>Retail and Distribution</Link></li>
                <li><Link className="dropdown-item" to="/consumer-goods" onClick={handleLinkClick}>Consumer Goods</Link></li>
                <li><Link className="dropdown-item" to="/construction" onClick={handleLinkClick}>Construction</Link></li>
                <li><Link className="dropdown-item" to="/media-and-entertainment" onClick={handleLinkClick}>Media and Entertainment</Link></li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/careers-hub" onClick={handleLinkClick}>Careers Hub</Link>
            </li>

          </ul>

          <Link to="/contact-us" className="quote-btn" onClick={handleLinkClick}>
            Contact Us →
          </Link>

        </div>
      </div>
    </nav>
  );
};

export default Header;